import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-cz",
  "use": "icon-flag-cz-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-cz\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 810.48V213.52L512 512z\" fill=\"#10457E\" opacity=\".75\" p-id=\"11434\" /><path d=\"M512 512L64 810.48h896V512z\" fill=\"#D61419\" opacity=\".75\" p-id=\"11435\" /><path d=\"M64 213.52L512 512h448V213.52z\" fill=\"#FFFFFF\" opacity=\".75\" p-id=\"11436\" /><path d=\"M960 229.52v-16H64l24.02 16z\" fill=\"#EEEEEE\" p-id=\"11437\" /><path d=\"M944 213.52h16V512h-16z\" fill=\"#EEEEEE\" p-id=\"11438\" /><path d=\"M88.02 794.48l-24.02 16h896v-16z\" fill=\"#D61419\" p-id=\"11439\" /><path d=\"M944 512h16v298.48h-16z\" fill=\"#D61419\" p-id=\"11440\" /><path d=\"M80 224.18l-16-10.66v596.96l16-10.66z\" fill=\"#10457E\" p-id=\"11441\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-cz.svg
// module id = 6Art
// module chunks = 24